import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { exchangeSession, attributeSignup } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    (async () => {
      if (sid) {
        try {
          const u = await exchangeSession(sid);
          setUser(u);
          const ref = localStorage.getItem("referrer_clip");
          if (ref) {
            if (u?.is_new) { try { await attributeSignup(ref); } catch { /* ignore */ } }
            localStorage.removeItem("referrer_clip");
          }
          const intended = localStorage.getItem("intended_plan");
          if (intended) {
            localStorage.removeItem("intended_plan");
            try {
              const { startCheckout } = await import("../lib/api");
              const { checkout_url } = await startCheckout(window.location.origin, intended);
              window.location.href = checkout_url;
              return;
            } catch { /* fall through to app */ }
          }
        } catch { /* fall through */ }
      }
      window.history.replaceState(null, "", window.location.pathname);
      navigate("/", { replace: true });
    })();
  }, [navigate, setUser]);

  return (
    <div className="flex h-screen items-center justify-center bg-background text-accent">
      <Loader2 className="h-8 w-8 animate-spin" />
    </div>
  );
}
